import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, useEffect } from 'react';
import { getOwnerDocument } from '@reach/utils';
import { useComposedRefs } from '../../hooks/useComposedRefs.js';
import { useTheme } from '../../hooks/useTheme.js';
import { Box } from '../../Box/index.js';
import { Popover } from '../../Popover/Popover.js';
import '../../Popover/PopoverImpl.js';
import 'tabbable';
import { useToggleTipContext } from './ToggleTipProvider.js';
import { useToggleTipPopover } from '../hooks/useToggleTipPopover.js';
import { useToggleTipPosition } from '../hooks/useToggleTipPosition.js';

var ToggleTipPopover = forwardRef(function ToggleTipPopover(_a, ref) {
    var children = _a.children, onBlur = _a.onBlur, _b = _a.portal, portal = _b === void 0 ? true : _b, position = _a.position, _c = _a.width, width = _c === void 0 ? "fit-content" : _c, _d = _a.maxWidth, maxWidth = _d === void 0 ? 240 : _d, sx = _a.sx, props = __rest(_a, ["children", "onBlur", "portal", "position", "width", "maxWidth", "sx"]);
    var mergeStyles = useTheme().mergeStyles;
    var _e = useToggleTipContext(), buttonRef = _e.buttonRef, popoverRef = _e.popoverRef, _f = _e.state, isOpen = _f.isOpen, contextDirection = _f.direction;
    var getPopoverPosition = useToggleTipPosition().getPopoverPosition;
    var _g = useToggleTipPopover(), mouseListener = _g.mouseListener, keyListener = _g.keyListener;
    var forwardedRef = useComposedRefs(popoverRef, ref);
    var direction = contextDirection || "up";
    var popoverPosition = position || getPopoverPosition(direction);
    useEffect(function () {
        if (!isOpen) {
            return;
        }
        var ownerDocument = getOwnerDocument(popoverRef.current);
        if (ownerDocument) {
            ownerDocument.addEventListener("mousedown", mouseListener);
            ownerDocument.addEventListener("keydown", keyListener);
        }
        // Comments inherited from @reach:
        // see https://github.com/reach/reach-ui/pull/700#discussion_r530369265
        // ownerDocument.addEventListener("touchstart", listener);
        return function () {
            if (ownerDocument) {
                ownerDocument.removeEventListener("mousedown", mouseListener);
                ownerDocument.removeEventListener("keydown", keyListener);
                // Comments inherited from @reach:
                // ownerDocument.removeEventListener("touchstart", listener);
            }
        };
    }, [isOpen]);
    var baseStyle = {
        position: "absolute",
        width: width,
        maxWidth: maxWidth,
    };
    var commonProps = __assign({ ref: forwardedRef, hidden: !isOpen, 
        // close popover if remove focus from the input/button (if there is any) in the popover content, disabled for now.
        // onBlur: composeEventHandlers(onBlur, (event) => {
        //   if (event.currentTarget.contains(event.relatedTarget as Node)) {
        //     return;
        //   }
        //   dispatch({ type: CLOSE_TOOGLETIP });
        // }),
        onBlur: onBlur, sx: mergeStyles([baseStyle, sx]) }, props);
    return portal ? (jsx(Popover, __assign({}, commonProps, { targetRef: buttonRef, position: popoverPosition }, { children: children }))) : (jsx(Box, __assign({}, commonProps, { children: children })));
});

export { ToggleTipPopover };
//# sourceMappingURL=ToggleTipPopover.js.map
